module.exports = __webpack_public_path__ + "static/media/eu.229aaa81.jpg";